/**
 * Convert a number that was previously converted to locale string (i.e. to display in the UI) to number to be saved to
 * the DB or to be used in a form.
 * @param localString A number currently in locale string format.
 */
export const convertLocaleStringToNumber = (localeString: string): number => {
    return parseInt(localeString.replaceAll(",", ""));
  };
  export function formatFilename(filename: string | File): string {
    if (filename instanceof File) {
      filename = filename.name;
    }
    if (!filename) {
      return "No File Chosen"
    }
    const fileExtension = filename.substring(filename.lastIndexOf("."));
    const start = filename.substring(0, 8);
    const end = filename.substring(
      filename.lastIndexOf(".") - 4,
      filename.lastIndexOf(".")
    );
    return `${start}.....${end}${fileExtension}`;
  }